import api from './api';

export const locationTrialDetailsService = {
  // Get location trial details
  async getLocationTrialDetails(locationId) {
    try {
      const response = await api.get(`/location-trial-details/location/${locationId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch location trial details');
    }
  },

  // Create location trial details
  async createLocationTrialDetails(data) {
    try {
      const response = await api.post('/location-trial-details', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create location trial details');
    }
  },

  // Update location trial details
  async updateLocationTrialDetails(id, data) {
    try {
      const response = await api.put(`/location-trial-details/${id}`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update location trial details');
    }
  },

  // Delete location trial details
  async deleteLocationTrialDetails(id) {
    try {
      const response = await api.delete(`/location-trial-details/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete location trial details');
    }
  }
};

export default locationTrialDetailsService;
